export default __webpack_public_path__ + "static/media/facebookIcon.bf1f327a.svg";